import { ROADSIDE_SERVICES_CODES } from 'entities/roadsideServices';
import { STATION_COLLOR_PALETTE } from 'common/constants/stationCollorPalette';
import { IRoadsideServiceIconsMap } from './types';

export const ROADSIDE_SERVICE_ICONS_MAP: IRoadsideServiceIconsMap = {
  [ROADSIDE_SERVICES_CODES.gasStation]:  { icon: 'localGasStationOutlined' },
  [ROADSIDE_SERVICES_CODES.roadPay]:     { icon: 'road' },
  [ROADSIDE_SERVICES_CODES.parking]:     { icon: 'parking' },
  [ROADSIDE_SERVICES_CODES.carWash]:     { icon: 'localCarWashOutlined' },
  [ROADSIDE_SERVICES_CODES.autoService]: { icon: 'buildOutlined' },
  [ROADSIDE_SERVICES_CODES.guard]:       { icon: 'guard' },
  [ROADSIDE_SERVICES_CODES.boat]:        { icon: 'directionsBoatOutlined' },
  [ROADSIDE_SERVICES_CODES.railway]:     { icon: 'directionsRailwayOutlined' },
  [ROADSIDE_SERVICES_CODES.store]:       { icon: 'storeMallDirectoryOutlined' },
  [ROADSIDE_SERVICES_CODES.cafe]:        { icon: 'localCafeOutlined' },
  [ROADSIDE_SERVICES_CODES.truckWash]:   { icon: 'truckWash' },
  [ROADSIDE_SERVICES_CODES.automobileWash]: { icon: 'localCarWashOutlined' },
  [ROADSIDE_SERVICES_CODES.evCharging]: { icon: 'charging' },
  [ROADSIDE_SERVICES_CODES.onlineBookingParking]: { icon: 'onlineBookingParking' }
};

export const getRoadsideServiceIcon = (id: number) => {
  const { icon = '' } = ROADSIDE_SERVICE_ICONS_MAP[id] || {};

  if (icon) return { icon };

  return {};
};

export const getRoadsideServiceIconSettings = (id: number) => {
  const icon = getRoadsideServiceIcon(id);
  return { iconColor: STATION_COLLOR_PALETTE.roadService, ...icon };
};
